module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTg5NiA5NmEzMiAzMiAwIDAgMSAzMiAzMnY3NjhhMzIgMzIgMCAwIDEtMzIgMzJIMTI4YTMyIDMyIDAgMCAxLTMyLTMyVjEyOGEzMiAzMiAwIDAgMSAzMi0zMmg3Njh6IG0tMTEyIDU5MmgtNTQ0YTQ4IDQ4IDAgMCAwIDAgOTZoNTQ0YTQ4IDQ4IDAgMCAwIDAtOTZ6IG0wLTIyNGgtNTQ0YTQ4IDQ4IDAgMCAwIDAgOTZoNTQ0YTQ4IDQ4IDAgMCAwIDAtOTZ6IG0wLTIyNGgtNTQ0YTQ4IDQ4IDAgMCAwIDAgOTZoNTQ0YTQ4IDQ4IDAgMCAwIDAtOTZ6IiBmaWxsPSIjMCIgcC1pZD0iMzAyOSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Hamburger-filled.svg
// module id = nir1
// module chunks = 75